import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { DemoModal } from "../../../../src/components/DemoModal";
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import * as React from 'react';
export default {
  Link,
  DemoModal,
  LeadParagraph,
  React
};